
export const COLORS={
    pinkColor:"#E36899",
    primaryColor:"#E36899",
    secondaryColor:"#592F80",
    purpleColor:"#592F80",
    overlayColor:"rgba(128, 0, 128, 0.6)",
    greyColor:"#484444",
    whiteColor:"#fff",
    blackColor:"#000",
    blueColor:"#007bff",
    lightgreenColor:"#F0E6F0",
    lightBlueColor:"#3498DB",
    lightGreyColor:"#f8f9fa",
    darkGreyColor:"#343a40"

}

export const fontFamilyAll="Nunito Sans";


